import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
/* eslint-disable react/require-default-props */
import { useCallback, useState } from "react";
import { apiGetProductInfo } from "Root/api/apiCheckout";
import { GainfulButton } from "CheckoutComponents";
import x from "Images/checkout/x.svg";
import styles from "./styles.module.css";
import { useDispatch } from "react-redux";
import LoadCurrentProductThunk from "Root/profile/redux/thunkCreators/products/currentProduct";
import CheckoutResultsProductDetailsDrawer from "../CheckoutResultsNew/CheckoutResultsProduct/CheckoutResultsProductDetailsDrawer";
const ProductCard = ({ image, category, title, type, description, label, isRow, isCentered, regularPrice, netPrice, servings, addToCart, removeFromCart, cartItem, ingredientInfo = {
    ingredients: [],
    nutrition_facts: "",
    product_title: "",
    product_key: "",
    name: "",
    macros: [],
    key_benefits: [],
}, }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [productData, setProductData] = useState(null);
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState({
        nutrition: false,
        ingredients: false,
        benefits: false,
        how_to_use: false,
        amino_acid: false,
    });
    const fetchProductData = (product) => {
        const getProductInfo = async (key) => {
            const data = (await apiGetProductInfo(key));
            if (data) {
                setProductData(data);
            }
        };
        getProductInfo(product);
    };
    const removeProductFromCart = useCallback(() => {
        removeFromCart && removeFromCart(type);
    }, [removeFromCart, type]);
    const addProductToCart = useCallback(() => {
        const item = category === "hydration" || category === "preworkout" ? category : type;
        if (type === "boost") {
            addToCart && addToCart(title.toLowerCase());
        }
        else {
            addToCart && addToCart(item);
        }
    }, [addToCart, category, type, title]);
    const isGreens = title.toLowerCase().includes("greens");
    const openDrawer = (product) => {
        if (product === "blenderbottle" ||
            product === "waterbottle" ||
            product === "wb221" ||
            product === "wb222" ||
            product === "other")
            return;
        // only fetch product data if it wasn't fetched before
        const params = product === "boost" ? title.toLocaleLowerCase() : product;
        if (!productData) {
            fetchProductData(params);
        }
        setIsDrawerOpen(true);
    };
    const toggleDrawer = (value) => () => {
        if (["blenderbottle", "waterbottle", "wb221", "wb222", "other"].includes(cartItem?.item_key))
            return;
        setIsDrawerOpen(value);
        if (value && cartItem?.item_type) {
            dispatch(LoadCurrentProductThunk(type === "boost" ? title.toLowerCase() : cartItem?.item_type));
        }
    };
    const price = regularPrice && netPrice !== regularPrice ? (_jsxs(_Fragment, { children: [_jsx("span", { className: `${styles.netPrice} ${styles.price}`, children: netPrice }), "\u00A0", _jsx("span", { className: `${styles.regularPrice} ${styles.price}`, children: regularPrice })] })) : (_jsx("span", { className: `${styles.price}`, children: netPrice }));
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: `${styles.card} ${isRow ? styles.cardrow : ""} ${isCentered ? styles.cardcentered : ""}`, children: [_jsx("div", { className: styles.imgwrapper, onClick: toggleDrawer(true), onKeyPress: toggleDrawer(true), role: "button", tabIndex: 0, children: _jsx("img", { src: image, alt: title, className: styles.img }) }), _jsxs("div", { className: styles.details, children: [!isGreens && (_jsx("div", { className: styles.category, children: category.replace("_", " ") })), _jsx("div", { className: styles.name, onClick: toggleDrawer(true), onKeyPress: toggleDrawer(true), role: "button", tabIndex: 0, children: title }), _jsxs("div", { className: styles.copy, children: [description || (_jsxs(_Fragment, { children: [!!servings && (_jsxs(_Fragment, { children: [servings, " ", _jsx("span", { className: styles.pipe, children: "|" }), "\u00A0"] })), price] })), addToCart && _jsx("div", { className: styles.price, children: price })] }), label && label?.length > 0 && (_jsx("div", { className: `${styles.label}`, children: label })), ![
                                "blenderbottle",
                                "waterbottle",
                                "wb221",
                                "wb222",
                                "other",
                            ].includes(type) && (_jsx("button", { type: "button", className: styles.detailsbtn, onClick: toggleDrawer(true), "aria-label": "More details", children: "More details" })), addToCart && (_jsx(GainfulButton, { text: "Add", onClick: addProductToCart, size: "w100", style: ["blenderbottle", "waterbottle", "wb221", "wb222"].includes(type)
                                    ? { marginTop: "auto" }
                                    : {} })), removeFromCart && !["other"].includes(type) && (_jsx("button", { type: "button", className: styles.remove, onClick: removeProductFromCart, "aria-label": "Remove from cart", children: _jsx("img", { alt: "remove", src: x }) }))] })] }), _jsx(CheckoutResultsProductDetailsDrawer, { openDrawer: isDrawerOpen, toggleDrawer: toggleDrawer, product: cartItem, ingredientInfo: ingredientInfo, expanded: expanded, setExpanded: (value) => setExpanded(value) })] }));
};
export default ProductCard;
